import { faTv, faTabletScreenButton } from "@fortawesome/pro-light-svg-icons"
import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { TroubleshootingTypeContent } from "./TroubleshootingCards"
import { HelpSection } from "./HelpSection"
import { HelpCard } from "./HelpCard"

type TroubleshootingProps = Readonly<{
    handleCardClick: (type: TroubleshootingTypeContent) => void
}>

export const Troubleshooting = ({ handleCardClick }: TroubleshootingProps) => {
    return (
        <LocalizedStrict id="help-dialog-troubleshooting" attrs={{ title: true }}>
            <HelpSection title="Troubleshooting">
                <LocalizedStrict id="help-dialog-troubleshooting-pos-screen" attrs={{ title: true, description: true }}>
                    <HelpCard
                        icon={faTv}
                        title="POS screen"
                        description="Get help for your POS screen, receipt printer and credit card terminal."
                        handleCardClick={() => handleCardClick("pos")}
                    />
                </LocalizedStrict>
                <LocalizedStrict
                    id="help-dialog-troubleshooting-check-in-screen"
                    attrs={{ title: true, description: true }}
                >
                    <HelpCard
                        icon={faTabletScreenButton}
                        title="Check in screen"
                        description="Get help for your check in screen and receipt printer."
                        handleCardClick={() => handleCardClick("check-in")}
                    />
                </LocalizedStrict>
            </HelpSection>
        </LocalizedStrict>
    )
}
